import { StyleSheet } from "react-native-unistyles";

import opacity from "$src/core/utils/color/opacity";

const stylesheet = StyleSheet.create(({ colors }) => ({
  fallback: {
    backgroundColor: opacity(colors.backgroundFloat, 0.55),
    _web: {
      backdropFilter: "blur(20px)",
    },
  },
}));

export default stylesheet;
